import { ImageSlide } from './ImageSlide';
import { SlideBuilder } from './SlideBuilder';
import { VideoSlide } from './VideoSlide';

export { Slide as LegacySlide } from './Slide';

export const slideVariations = {
  'image-slide': ImageSlide,
  'video-slide': VideoSlide,
  'slide-builder': SlideBuilder
};
